import { render, staticRenderFns } from "./ArchivosGrua.vue?vue&type=template&id=f0d08e62&"
import script from "./ArchivosGrua.vue?vue&type=script&lang=js&"
export * from "./ArchivosGrua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports